import * as React from "react";

function SvgUserAccountDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75a9.71 9.71 0 01-6.657-2.627l-.25-.242A9.717 9.717 0 012.25 12 9.75 9.75 0 0112 2.25zm0 1.5a8.25 8.25 0 00-6.317 13.556 8.814 8.814 0 015.342-2.05l.318-.006h1.213c1.626 0 3.217.45 4.6 1.295l.293.187.867.576A8.25 8.25 0 0012 3.75zM12 6a3.75 3.75 0 013.745 3.55l.005.2v.5a3.75 3.75 0 01-7.495.2l-.005-.2v-.5A3.75 3.75 0 0112 6z"
        />
        <path
          fill="#98DB69"
          d="M12.556 16.75l.31.007a7.306 7.306 0 013.75 1.223l.61.405A8.229 8.229 0 0112 20.25a8.203 8.203 0 01-5.245-1.884 7.325 7.325 0 014.588-1.616h1.213zM12 7.5a2.25 2.25 0 012.25 2.25v.5l-.005.154a2.25 2.25 0 01-4.495-.154v-.5l.005-.154A2.252 2.252 0 0112 7.5z"
        />
      </g>
    </svg>
  );
}

export default SvgUserAccountDuo;
